export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-10-db1a0810e114dbd0801b8908782e5757.jpg";